import {
  Button,
  Card,
  Flex,
  Grid,
  Input,
  message,
  Pagination,
  Table,
  Typography,
} from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router";
import useTitleStore from "../../../store/titleStore";
import { useTableHeight } from "../../../hooks/useTableHeight";
import TableAction from "../../../components/TableAction";

export default function AccessIndex() {
  const breakpoint = Grid.useBreakpoint();

  const navigate = useNavigate();
  const { setTitle } = useTitleStore();
  const tableHeight = useTableHeight();

  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
    setTitle("Master Data");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const columns = [
    {
      title: "No",
      align: "center",
      width: 20,
      render: (text, record, index) => index + 1,
      fixed: breakpoint.md && "left",
    },
    {
      title: "Nama",
      dataIndex: "name",
      width: 150,
      fixed: breakpoint.md && "left",
      render: (val) => (
        <Typography.Text style={{ fontWeight: 600 }}>{val}</Typography.Text>
      ),
    },
    // {
    //   title: 'Update By',
    //   width: 100,
    //   render: val => <UpdatedByCell value={val} />,
    // },
    {
      className: "last-cell-p",
      title: "Aksi",
      align: "right",
      width: 30,
      fixed: "right",
      render: (record) => (
        <TableAction
          onClickEdit={() => navigate("/setting/access/detail/" + record.id)}
          showDelete={false}
        />
      ),
    },
  ];

  return (
    <Card
      styles={{
        body: {
          paddingLeft: 0,
          paddingRight: 0,
        },
      }}
    >
      {contextHolder}
      <Table
        columns={columns}
        pagination={false}
        size="small"
        rowKey={"id"}
        scroll={{ y: tableHeight, x: 1100 }}
        dataSource={[
          {
            id: "1",
            name: "Direktur",
          },
          {
            id: "2",
            name: "Verifikator",
          },
        ]}
      />
    </Card>
  );
}
